/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * CustomModal
 *
 * @file  CustomModal.jsx
 * @author Gladson Samuel S
 * @since 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { CloseButton, Content, PaperStyled } from './Styles/CustomModalStyles';

const StyledDialog = styled(Dialog)({
  '&&': {}
});

const CustomModal = ({
  open,
  onClose,
  children,
  classes
}) => {
  const renderCloseButton = () => {
    if (!onClose) return null;

    return (
      <CloseButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    );
  };

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      className={classes.root}
      PaperComponent={PaperStyled}
      PaperProps={{ className: classes.paper }}
    >
      {renderCloseButton()}
      <Content className={classes.content}>
        {children}
      </Content>
    </StyledDialog>
  );
};

CustomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node,
  classes: PropTypes.object
};

CustomModal.defaultProps = {
  onClose: () => {},
  children: null,
  classes: {}
};

export default CustomModal;
